import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchList, fetchDelete } from '@/api/PMS/customerService/complaintManage';
import waves from '@/directive/waves'; // 水波纹指令

import complaintAdd from './add';
import complaintDetail from '../complaintQuery/detail';
export default {
  name: 'ComplexTable',
  components: {
    complaintAdd: complaintAdd,
    complaintDetail: complaintDetail
  },
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10,
        sysType: 2,
        pageTypePc: 4
      },
      complaintOption: [{
        name: '微信',
        value: 1
      }, {
        name: '电话',
        value: 2
      }, {
        name: '现场登记',
        value: 3
      }],
      statusOption: [{
        name: '未处理',
        value: 0
      }, {
        name: '处理中',
        value: 1
      }, {
        name: '已处理',
        value: 2
      }],
      sourceOption: [// { name: '微信', value: 1 },
      {
        name: '电话',
        value: 2
      }, {
        name: '现场登记',
        value: 3
      }],
      situationOption: [{
        name: '紧急',
        value: 0
      }, {
        name: '一般',
        value: 1
      }],
      title: '',
      complaintId: -1,
      flowNum: '',
      multipleSelection: [],
      dialogFormVisible: false,
      dialogFormDetailVisible: false
    };
  },
  created: function created() {
    if (location.hash === '#/complaintManage/newComplaint') {
      this.listQuery.sysType = 2;
    } else {
      this.listQuery.sysType = 1;
    }

    this.getList();
    console.log(location.hash, 'location');
  },
  methods: {
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormVisible = false;
    },
    isEdit: function isEdit(row, index) {
      if (row.status === 0) {
        return 1;
      } else {
        return 0;
      }
    },
    getList: function getList() {
      var _this = this;

      this.listLoading = true;
      fetchList(this.listQuery).then(function (response) {
        _this.list = response.data.data;
        _this.total = response.data.total;
        _this.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getFlowDetail: function getFlowDetail(id, flowNum) {
      this.complaintId = id;
      this.flowNum = flowNum;
      this.dialogFormDetailVisible = true;
      this.title = '投诉详情';
    },
    // 创建
    handleCreate: function handleCreate() {
      this.complaintId = -1;
      this.title = '投诉登记';
      this.dialogFormVisible = true;
    },
    // 编辑
    handleUpdate: function handleUpdate(complaintId) {
      this.complaintId = complaintId;
      this.title = '编辑';
      this.dialogFormVisible = true;
    },
    delete: function _delete(complaintIds) {
      var _this2 = this;

      if (complaintIds.length > 0) {
        this.$confirm('你确定是要删除这些记录, 是否继续?', '提示').then(function () {
          fetchDelete(complaintIds).then(function (response) {
            _this2.getList();

            _this2.Alert({
              alertType: 'delete'
            });
          });
        });
      } else {
        this.Alert({
          alertType: 'nodata'
        });
      }
    },
    handleDelete: function handleDelete(complaintId) {
      var complaintIds = [];
      complaintIds.push(complaintId);
      this.delete(complaintIds);
    },
    handleDeletes: function handleDeletes() {
      var complaintIds = [];
      this.multipleSelection.forEach(function (row) {
        complaintIds.push(row.complaintId);
      });
      this.delete(complaintIds);
    }
  }
};